/***
*
*   VIEW
*   The view houses global components that are common to all views
*   (notification, modal), handles errors and renders the layout
*
**********/

import React, { useState, useEffect } from 'react';
import { AppLayout, AppDarkLayout, AppDarkBareLayout, AuthLayout, HomeLayout, OnboardingLayout, 
  Modal, Notification, Loader, useNavigate } from '../lib';

// import './scss/normalize.scss';
// import './scss/view.scss';
// import './scss/typography.scss';

export const ViewContext = React.createContext();

export function View(props){

  //console.log("View");
  //console.log(props);

  const navigate = useNavigate();

  // state
  const [notification, setNotification] = useState({ visible: 'hide', autoclose: true });
  const [modal, setModal] = useState({});
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(null);
  const [advanced, setAdvanced] = useState(props.advancedState);

  // layouts
  const layouts = {

    app: AppLayout,
    appDark: AppDarkLayout,
    appDarkBare: AppDarkBareLayout,
    home: HomeLayout,
    auth: AuthLayout,
    onboarding: OnboardingLayout,
 
  }

  // set title & layout
  document.title = props.title;
  
  let Layout = props.layout ? layouts[props.layout] : AppLayout;

  /*useEffect(() => {
    if(localStorage.getItem("advancedState")){
      if(localStorage.getItem("advancedState") && ((localStorage.getItem("advancedState")==="true") || (localStorage.getItem("advancedState")===true))){
        console.log("BASIC");
        setAdvanced(true);
      } else {
        console.log("NOT BASIC");
        setAdvanced(false);
      }
    }

  }, []);*/

  useEffect(() => {
    if(props.title){
      setTitle(props.title);
    }
  }, [props]);

  if (!props.display)
    return false;

  function showNotification(text, type, autoclose, format, icon){

    setNotification({

      text: text,
      type: type,
      show: true,
      format: format,
      icon: icon,
      autoclose: autoclose

    });

    if (autoclose) setTimeout(hideNotification, 2000);

  }

  function hideNotification(){

    setNotification({

      text: '',
      type: '',
      show: false,
      format: null,
      icon: null,
      autoclose: true

    });
  }

  function showModal(content, callback){

    let data = {...modal }

    if (content){

      for (let key in content)
        data[key] = content[key];

      data.show = true;
      data.callback = callback;

    }

    setModal(data);

  }

  function hideModal(cancel, res){

    // callback?
    if (!cancel && modal.callback){
      modal.callback(modal.form, res);
    }

    if (cancel && modal.callback){
      modal.callback(modal.form, null);
    }



    // reset the modal
    setModal({

      title: null,
      text: null,
      buttonText: null,
      url: null,
      method: null,
      show: false,

    });
  }

  function handleError(err){

    let message = 'There was a glitch in the matrix – please try again';

    if (err){

      message = err.toString();

      if (err.response){

        if (err.response.data?.message)
          message = err.response.data.message

        if (err.response.status){
          switch (err.response.status){

            case 401:
            console.log("Auth error");
            //navigate('/signin');
            break;

            case 404:
              navigate('/notfound');
            break;

            case 429:
            showNotification(err.response.data, 'error', false);
            break;

            case 402: // payment required
            navigate('/account/upgrade?plan=' + err.response.data.plan);
            break;

            default:
            console.error(err);
            showNotification(message, 'error', false);
            break;

          }
        }
      }
    }
  }

  function getAdvanced(){
    //console.log("advanced? " + advanced);
    return advanced;
  }

  function setAndStoreAdvanced(advancedState){
    
    localStorage.setItem("advancedState",advancedState);
    setAdvanced(advancedState);
  }

  const context = {

    notification: {

      show: showNotification,
      hide: hideNotification,
      data: notification,

    },
    modal: {

      show: showModal,
      hide: hideModal,
      data: modal,

    },
    setAdvanced: advancedState=>setAndStoreAdvanced(advancedState),
    setTitle: title=>setTitle(title),
    setLoading: state => setLoading(state),
    handleError: handleError,
    isAdvanced: getAdvanced()

  }

  
  return (
    <ViewContext.Provider value={ context }>

      { notification.show &&
        <Notification {...notification }/> }

      { loading && 
        <Loader fullScreen /> }

      { modal.show &&
        <Modal {...modal } /> }

        <Layout title={ title } data={ props.data }>
          { props.display }
          
        </Layout>

    </ViewContext.Provider>
  );
}
